import { render } from "./IconQrReload.vue?vue&type=template&id=1edc2545"
import script from "./IconQrReload.vue?vue&type=script&lang=js"
export * from "./IconQrReload.vue?vue&type=script&lang=js"
script.render = render

export default script